<!-- <h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content>
    <ng-container *ngIf="data.content">
        <ng-container *ngTemplateOutlet="data.content; context: { close: data.closeFn }"></ng-container>
    </ng-container>
</mat-dialog-content> -->

<div class="baoTitleCC">
    <h2 mat-dialog-title class="Title__popupCC">{{ data.title }}</h2>
    
    <span class="span__pCC" mat-dialog-close>
        <i class="ti ti-x"></i>
    </span>
</div>

<mat-dialog-content>
  <!-- Dialog xác nhận -->
  <div *ngIf="isConfirmationDialog()" class="confirmation-dialog">
    <p class="confirmation-message">{{ data.content }}</p>
  </div>

  <!-- Dialog chọn template -->
  <div *ngIf="isTemplateSelectionDialog()" class="template-selection-dialog">
    <p class="template-selection-message">{{ data.content }}</p>
    <div class="template-list">
      <div *ngFor="let template of data.templateList" 
           class="template-item" 
           [class.selected]="isTemplateSelected(template.Id)"
           (click)="selectTemplate(template.Id)">
        <div class="template-info">
          <div class="template-name">{{ template.TemplateFileName || 'Template' }}</div>
        </div>
        <div class="template-radio">
          <input type="radio" 
                 [checked]="isTemplateSelected(template.Id)"
                 (click)="selectTemplate(template.Id)">
        </div>
      </div>
    </div>
  </div>

  <!-- Form thông thường -->
  <form *ngIf="!isConfirmationDialog() && !isTemplateSelectionDialog()">
    <div class="row">
      <div class="col-md-6">
        <div class="full-width__CC">
            <p class="m-b-10 m-t-10 popup__CCCC">Mã cán bộ <span>*</span></p>
            <digi-text label="Nhập nội dung..." errorMessage="Chưa nhập nội dung"></digi-text>
        </div>
      </div>
      <div class="col-md-6">
        <div class="full-width__CC">
            <p class="m-b-10 m-t-10 popup__CCCC">Tên cán bộ <span>*</span></p>
            <digi-text label="Nhập nội dung..." errorMessage="Chưa nhập nội dung"></digi-text>
        </div>
      </div>
    </div>

    <div class="row m-t-20">
      <div class="col-md-12">
        <label for="txtattactments" class="form-label">File đính kèm</label>
        <input type="file" #fileInput id="listAttactments" multiple accept=".doc, .docx, .pdf" 
               (change)="onFileSelected($event)" hidden>
        <button type="button" class="choose-file" (click)="fileInput.click()">
          Chọn File
        </button>
        <span class="e-float-line"></span>

        <!-- Hiển thị danh sách file đã chọn -->
        <ul *ngIf="selectedFiles.length > 0">
          <li *ngFor="let file of selectedFiles; let i = index">
            {{ file.name }} ({{ (file.size / 1024).toFixed(2) }} KB)
            <button type="button" (click)="removeFile(i)" style="color: red; border: none; background: none;">✖</button>
          </li>
        </ul>
      </div>
    </div>

    <!-- Kéo thả ảnh đại diện -->
    <div class="row m-t-20">
      <div class="col-md-12">
        <label class="form-label">Ảnh đại diện</label>
        <div 
          class="drop-zone" 
          (click)="triggerFileInput()"
          (dragover)="onDragOver($event)" 
          (dragleave)="onDragLeave()" 
          (drop)="onDrop($event)">
          <p>Kéo thả hoặc nhấn vào đây để tải ảnh</p>
          <input type="file" #avatarInput accept=".jpg,.jpeg,.png,.svg" (change)="onAvatarSelected($event)" hidden>
        </div>
        <div class="image-preview" *ngIf="selectedAvatars.length > 0">
          <div class="image-container" *ngFor="let avatar of selectedAvatars; let i = index">
            <img [src]="avatar.url" class="preview-img">
            <button type="button" class="delete-btn" (click)="removeAvatar(i)">Xóa</button>
          </div>
        </div>
      </div>
    </div>

  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <!-- Nút cho dialog xác nhận -->
  <ng-container *ngIf="isConfirmationDialog()">
    <button class="Btn__custom-cancel" mat-button (click)="onCancel()">
      <i class="ti ti-xbox-x-filled icon__customAlert"></i>
      {{ data.cancelText || 'Hủy' }}
    </button>
    <button class="Btn__custom-save" mat-button color="primary" (click)="onConfirm()">
      <i class="ti ti-check icon__customAlert"></i>
      {{ data.confirmText || 'Xác nhận' }}
    </button>
  </ng-container>

  <!-- Nút cho dialog chọn template -->
  <ng-container *ngIf="isTemplateSelectionDialog()">
    <button class="Btn__custom-cancel" mat-button (click)="onCancel()">
      <i class="ti ti-xbox-x-filled icon__customAlert"></i>
      {{ data.cancelText || 'Hủy' }}
    </button>
    <button class="Btn__custom-save" mat-button color="primary" (click)="confirmTemplateSelection()">
      <i class="ti ti-check icon__customAlert"></i>
      {{ data.confirmText || 'Chọn template' }}
    </button>
  </ng-container>

  <!-- Nút cho form thông thường -->
  <ng-container *ngIf="!isConfirmationDialog() && !isTemplateSelectionDialog()">
    <button class="Btn__custom-cancel" mat-button mat-dialog-close>
      <i class="ti ti-xbox-x-filled icon__customAlert"></i>
      Hủy
    </button>
    <button class="Btn__custom-save" mat-button color="primary" (click)="saveFiles()">
      <i class="ti ti-check icon__customAlert"></i>
      Lưu thông tin
    </button>
  </ng-container>
</mat-dialog-actions>
